const search = { ko: "검색", en: "Search", es: "Buscar" }

const SearchButton = ({ onClick, lang = "ko", label }) => {
  return (
    <button
      onClick={onClick}
      className="bg-[rgba(0,27,55,0.1)] font-semibold cursor-pointer hover:bg-[rgba(0,27,55,0.2)]
      rounded-lg text-sm h-8 px-3.5
      "
    >
      {label ?? search[lang]}
    </button>
  )
}

export default SearchButton
